var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewBadge = function SvgNewBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 68 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#new-badge_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.105 4h-3.854c-.812 0-1.47.657-1.47 1.466v6.083l-5.463-6.986A1.474 1.474 0 0 0 9.16 4H6.47C5.659 4 5 4.657 5 5.466v17.067C5 23.343 5.659 24 6.47 24h3.828c.811 0 1.47-.657 1.47-1.466v-5.946l5.342 6.846c.279.358.705.566 1.16.566h2.835c.811 0 1.47-.657 1.47-1.466V5.465c0-.809-.659-1.466-1.47-1.466ZM62.714 4.604A1.472 1.472 0 0 0 61.526 4h-3.78a1.47 1.47 0 0 0-1.406 1.038l-1.852 6.042-1.805-6.033A1.468 1.468 0 0 0 51.275 4H48.27a1.47 1.47 0 0 0-1.408 1.05l-1.785 6.01-1.846-6.022A1.47 1.47 0 0 0 41.826 4h-3.804c-.265 0-.52.073-.744.202A1.461 1.461 0 0 0 36.543 4h-12.19c-.81 0-1.47.657-1.47 1.466v17.067c0 .81.66 1.467 1.47 1.467h12.334c.811 0 1.47-.657 1.47-1.466v-3.288c0-.81-.659-1.467-1.47-1.467h-7.035v-.886h6.162c.811 0 1.47-.657 1.47-1.466v-3.215c0-.81-.659-1.466-1.47-1.466H29.65v-.525h6.892c.529 0 .988-.282 1.246-.698l4.357 13.462a1.472 1.472 0 0 0 1.4 1.015h2.98c.65 0 1.22-.425 1.409-1.044l1.835-6.083 1.846 6.086A1.47 1.47 0 0 0 53.024 24h2.981c.638 0 1.203-.41 1.4-1.015l5.524-17.067a1.458 1.458 0 0 0-.212-1.314h-.003Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5F48FB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.254 15.811 9.16 5.466H6.47v17.067h3.828V12.319l7.973 10.216h2.834V5.465h-3.851v10.345ZM28.182 15.427h7.632v-3.215h-7.632V8.754h8.36V5.466H24.355v17.067h12.333v-3.287h-8.505v-3.82ZM57.746 5.466 54.47 16.151 51.275 5.466H48.27l-3.175 10.68-3.272-10.68h-3.804l5.527 17.067h2.978l3.24-10.737 3.254 10.738H56l5.525-17.068h-3.778Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "new-badge_svg__a",
    x: 0,
    y: 0,
    width: 68,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2038_735"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2038_735",
    result: "effect2_dropShadow_2038_735"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    "in": "SourceAlpha",
    result: "effect3_dropShadow_2038_735"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_2038_735",
    result: "effect3_dropShadow_2038_735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_2038_735",
    result: "shape"
  })))));
};
export default SvgNewBadge;